import { createSystemEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IGender } from "../../utils/types/models";

export default createSystemEntityReducer<IGender>(Endpoint.Genders);
